export const TABLE_COLUMNS_NAME = [
  {
    label: 'Placa',
    key: 'plate',
  },
  {
    label: 'Ident',
    key: 'ident',
  },
  {
    label: 'Etiqueta',
    key: 'label',
  },
  {
    label: 'Comando Enviado',
    key: 'commandType',
  },
  {
    label: 'Fecha Solicitud',
    key: 'created',
  },
  {
    label: 'Estatus',
    key: 'status',
  },
  {
    label: 'Acciones',
    key: 'actions',
  },
];

export const COMMAND_PENDING_STATUS = 'Pendiente';
export const COMMAND_SUCCESS_STATUS = 'Completado';
export const COMMAND_EXPIRED_STATUS = 'Expirado';

export const COMMANDS_STATUS: { [key: string]: string } = {
  pending: COMMAND_PENDING_STATUS,
  success: COMMAND_SUCCESS_STATUS,
  expired: COMMAND_EXPIRED_STATUS,
};
